<template>
  <div class="h-full">
    <a-row :gutter="16" type="flex">
      <a-col :span="4">
        <a-tree
          :autoExpandParent="autoExpandParent"
          :expandedKeys="iExpandedKeys"
          :selectedKeys="selectedKeys"
          :treeData="departTree"
          @expand="onExpand"
          @select="onSelect"
        />
      </a-col>
      <a-col :span="20">
        <KFormDesign ref="kfd" :hideModel="true" :showHead="false" @save="handleSaveFn"> </KFormDesign>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAction, postAction, putAction } from '@/api/manage'
import { queryDepartTreeList, searchByKeywords, deleteByDepartId } from '@/api/api'
// import FcDesignerVue from 'form-create-designer-ant'
// import FormDesign from '@/components/KFormDesign/packages/index.js';
import { KFormDesign } from '@/components/KFormDesign/packages/index.js'
import '@/components/KFormDesign/styles/form-design.less'

export default {
  desc: '交接班表单设置',
  name: 'FormDesigner',
  components: { KFormDesign },
  // 定义属性
  data() {
    return {
      generaFormData: {
        id: ''
      },
      sysOrgCode: '',
      treeData: [],
      departTree: [],
      allTreeKeys: [],
      autoExpandParent: true,
      iExpandedKeys: [],
      selectedKeys: [],
      autoExpandParent: true
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // await deleteAction('/custom/customForm/delete', { id: '1647597153310449666' })
    // this.initGetData()
    this.loadTree()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    getDataType(options, type) {
      const typeArray = ['checkbox']
      if (typeArray.includes(type) || (type === 'select' && options?.multiple)) {
        return 'array'
      }
      return 'string'
    },
    handleSaveFn(e) {
      const { list } = JSON.parse(e)
      if (list.length == 0) {
        this.$message.error('表单项不能为空！')
        return
      }
      console.info('save designer form===Object', list)

      console.info('save designer form===', JSON.stringify(list))

      const params = {
        formJson: e,
        bizType: 1,
        formName: '1',
        sysOrgCode: this.sysOrgCode,
        list: list.reduce((pre, cur) => {
          const hidden = cur.hidden ? '1' : '0'
          const isAllowEmpty = cur?.rules?.[0].required ? '1' : '0'
          const dataType = this.getDataType(cur.options, cur.type)
          const options = cur?.options?.options?.reduce(
            (pre, cur) => {
              pre.value.push(cur.value)
              pre.label.push(cur.label)
              return pre
            },
            {
              value: [],
              label: []
            }
          )

          const item = {
            componentType: cur.type,
            dataType: dataType,
            propKey: cur.key,
            propName: cur.label,
            optionLabel: options?.label.join() ?? '',
            optionValue: options?.value.join() ?? '',
            isAllowEmpty: isAllowEmpty,
            isHide: hidden
          }
          pre.push(item)
          return pre
        }, [])
      }
      console.info('save designer params===params', params)

      const { id } = this.generaFormData
      if (!id) {
        // if(){}
        postAction('/custom/customForm/add', params).then(res => {
          if (res.success) {
            this.$message.success('添加成功')
          }
        })
      } else {
        putAction('/custom/customForm/edit', { ...params, id }).then(res => {
          if (res.success) {
            this.$message.success('编辑成功')
            getAction('/custom/customForm/queryById', { id }).then(queryRes => {
              if (queryRes.success) {
                this.loadDesigner(queryRes.result)
              }
            })
          }
        })
      }
    },
    initGetData(sysOrgCode) {
      this.sysOrgCode = sysOrgCode
      getAction('/custom/customForm/list', { type: '1', sysOrgCode }).then(res => {
        if (res.code === 200) {
          // this.formData = res.data
          // if (res.result.records.length > 0) {
          //   //       this.$refs.kfd.handleSetData(this.jsonData)
          //   this.loadDesigner(res.result.records[res.result.records.length - 1])
          // }
          this.loadDesigner(
            res.result.records[res.result.records.length - 1] || {
              formJson: JSON.stringify({
                config: {},
                list: []
              })
            }
          )
        }
      })
    },
    loadDesigner(generaFormData) {
      this.$refs.kfd.handleSetData(JSON.parse(generaFormData.formJson))
      this.generaFormData = generaFormData
    },
    loadTree() {
      var that = this
      that.treeData = []
      that.departTree = []
      queryDepartTreeList().then(res => {
        if (res.success) {
          // 部门全选后，再添加部门，选中数量增多
          this.allTreeKeys = []
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.treeData.push(temp)
            that.departTree.push(temp)
            that.setThisExpandedKeys(temp)
            that.getAllKeys(temp)
            // console.log(temp.id)
          }
          this.loading = false
        }
      })
    },
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },
    getAllKeys(node) {
      // console.log('node',node);
      this.allTreeKeys.push(node.key)
      if (node.children && node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          this.getAllKeys(node.children[a])
        }
      }
    },
    onSelect(selectedKeys, e) {
      let record = e.node.dataRef
      this.selectedKeys = [record.key]
      this.initGetData(record.orgCode)
    },
    onExpand(expandedKeys) {
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
